import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "hidden-visually" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 0,
  class: "conversation__subname-actor"
}
const _hoisted_5 = { class: "conversation__subname-message" }
const _hoisted_6 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ConversationIcon = _resolveComponent("ConversationIcon")
  const _component_IconStar = _resolveComponent("IconStar")
  const _component_NcActionButton = _resolveComponent("NcActionButton")
  const _component_IconContentCopy = _resolveComponent("IconContentCopy")
  const _component_IconEyeOutline = _resolveComponent("IconEyeOutline")
  const _component_IconEyeOffOutline = _resolveComponent("IconEyeOffOutline")
  const _component_IconBellOutline = _resolveComponent("IconBellOutline")
  const _component_IconCogOutline = _resolveComponent("IconCogOutline")
  const _component_IconArchiveOutline = _resolveComponent("IconArchiveOutline")
  const _component_IconArchiveOffOutline = _resolveComponent("IconArchiveOffOutline")
  const _component_IconExitToApp = _resolveComponent("IconExitToApp")
  const _component_IconTrashCanOutline = _resolveComponent("IconTrashCanOutline")
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")
  const _component_NcActionSeparator = _resolveComponent("NcActionSeparator")
  const _component_IconPhoneRingOutline = _resolveComponent("IconPhoneRingOutline")
  const _component_IconMessageAlertOutline = _resolveComponent("IconMessageAlertOutline")
  const _component_IconShieldLockOutline = _resolveComponent("IconShieldLockOutline")
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcDialog = _resolveComponent("NcDialog")
  const _component_NcListItem = _resolveComponent("NcListItem")

  return (_openBlock(), _createBlock(_component_NcListItem, {
    ref: "listItem",
    name: $props.item.displayName,
    title: $props.item.displayName,
    "data-nav-id": `conversation_${$props.item.token}`,
    class: _normalizeClass(["conversation", {
			'conversation--active': $options.isActive,
			'conversation--compact': $props.compact,
			'conversation--compact__read': $props.compact && !$props.item.unreadMessages,
		}]),
    "actions-aria-label": $options.t('spreed', 'Conversation actions'),
    to: $options.to,
    bold: !!$props.item.unreadMessages,
    "counter-number": $props.item.unreadMessages,
    "counter-type": $setup.counterType,
    "force-menu": "",
    compact: $props.compact,
    onClick: $options.onClick,
    "onUpdate:menuOpen": $options.handleActionsMenuOpen
  }, _createSlots({
    icon: _withCtx(() => [
      (_openBlock(), _createBlock(_component_ConversationIcon, {
        key: $props.item.token,
        item: $props.item,
        "hide-favorite": $props.compact,
        "hide-call": $props.compact,
        "hide-user-status": $props.item.type !== $setup.CONVERSATION.TYPE.ONE_TO_ONE && $props.compact,
        "show-user-online-status": $props.compact,
        size: $props.compact ? $setup.AVATAR.SIZE.COMPACT : $setup.AVATAR.SIZE.DEFAULT
      }, null, 8, ["item", "hide-favorite", "hide-call", "hide-user-status", "show-user-online-status", "size"]))
    ]),
    name: _withCtx(() => [
      ($props.compact && $options.iconType)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent($options.iconType.component), {
              size: 15,
              "fill-color": $options.iconType.color
            }, null, 8, ["fill-color"])),
            _createElementVNode("span", _hoisted_1, _toDisplayString($options.iconType.text), 1)
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_2, _toDisplayString($props.item.displayName), 1)
    ]),
    _: 2
  }, [
    (!$props.compact && !$props.item.isSensitive)
      ? {
          name: "subname",
          fn: _withCtx(() => [
            _createElementVNode("span", {
              class: "conversation__subname",
              title: $setup.conversationInformation.title
            }, [
              ($setup.conversationInformation.actor)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.conversationInformation.actor), 1))
                : _createCommentVNode("", true),
              ($setup.conversationInformation.icon)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.conversationInformation.icon), {
                    key: 1,
                    class: "conversation__subname-icon",
                    size: 16
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_5, _toDisplayString($setup.conversationInformation.message), 1)
            ], 8, _hoisted_3)
          ]),
          key: "0"
        }
      : undefined,
    (!$props.isSearchResult)
      ? {
          name: "actions",
          fn: _withCtx(() => [
            ($setup.submenu === null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  ($options.canFavorite)
                    ? (_openBlock(), _createBlock(_component_NcActionButton, {
                        key: "toggle-favorite",
                        "close-after-click": "",
                        onClick: $options.toggleFavoriteConversation
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_IconStar, {
                            size: 20,
                            "fill-color": !$props.item.isFavorite ? '#FFCC00' : undefined
                          }, null, 8, ["fill-color"])
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString($options.labelFavorite), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_NcActionButton, {
                    key: "copy-link",
                    onClick: _withModifiers($options.handleCopyLink, ["stop"])
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_IconContentCopy, { size: 20 })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Copy link')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_NcActionButton, {
                    key: "toggle-read",
                    "close-after-click": "",
                    onClick: $options.toggleReadConversation
                  }, {
                    icon: _withCtx(() => [
                      ($props.item.unreadMessages)
                        ? (_openBlock(), _createBlock(_component_IconEyeOutline, {
                            key: 0,
                            size: 20
                          }))
                        : (_openBlock(), _createBlock(_component_IconEyeOffOutline, {
                            key: 1,
                            size: 20
                          }))
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString($options.labelRead), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_NcActionButton, {
                    key: "show-notifications",
                    "is-menu": "",
                    onClick: _cache[0] || (_cache[0] = $event => ($setup.submenu = 'notifications'))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_IconBellOutline, { size: 20 })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Notifications')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_NcActionButton, {
                    key: "show-settings",
                    "close-after-click": "",
                    onClick: $options.showConversationSettings
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_IconCogOutline, { size: 20 })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Conversation settings')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  ($setup.supportsArchive)
                    ? (_openBlock(), _createBlock(_component_NcActionButton, {
                        key: "toggle-archive",
                        "close-after-click": "",
                        onClick: $options.toggleArchiveConversation
                      }, {
                        icon: _withCtx(() => [
                          (!$props.item.isArchived)
                            ? (_openBlock(), _createBlock(_component_IconArchiveOutline, {
                                key: 0,
                                size: 20
                              }))
                            : (_openBlock(), _createBlock(_component_IconArchiveOffOutline, {
                                key: 1,
                                size: 20
                              }))
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString($options.labelArchive), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  ($props.item.canLeaveConversation)
                    ? (_openBlock(), _createBlock(_component_NcActionButton, {
                        key: "leave-conversation",
                        "close-after-click": "",
                        onClick: _cache[1] || (_cache[1] = $event => ($setup.isLeaveDialogOpen = true))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_IconExitToApp, { size: 20 })
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Leave conversation')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ($props.item.canDeleteConversation)
                    ? (_openBlock(), _createBlock(_component_NcActionButton, {
                        key: "delete-conversation",
                        "close-after-click": "",
                        class: "critical",
                        onClick: _cache[2] || (_cache[2] = $event => ($setup.isDeleteDialogOpen = true))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_IconTrashCanOutline, { size: 20 })
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Delete conversation')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : ($setup.submenu === 'notifications')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_NcActionButton, {
                      key: "action-back",
                      "aria-label": $options.t('spreed', 'Back'),
                      onClick: _cache[3] || (_cache[3] = _withModifiers($event => ($setup.submenu = null), ["stop"]))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_IconArrowLeft, {
                          class: "bidirectional-icon",
                          size: 20
                        })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Back')), 1)
                      ]),
                      _: 1
                    }, 8, ["aria-label"]),
                    _createVNode(_component_NcActionSeparator),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.notificationLevels, (level) => {
                      return (_openBlock(), _createBlock(_component_NcActionButton, {
                        key: level.value,
                        "model-value": $options.notificationLevel,
                        value: level.value.toString(),
                        type: "radio",
                        onClick: $event => ($options.setNotificationLevel(level.value))
                      }, {
                        icon: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(level.icon), { size: 20 }))
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString(level.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["model-value", "value", "onClick"]))
                    }), 128)),
                    ($options.showCallNotificationSettings)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_NcActionSeparator),
                          _createVNode(_component_NcActionButton, {
                            key: "notification-calls",
                            type: "checkbox",
                            "model-value": $options.notificationCalls,
                            onClick: _cache[4] || (_cache[4] = $event => ($options.setNotificationCalls(!$options.notificationCalls)))
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_IconPhoneRingOutline, { size: 20 })
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Notify about calls')), 1)
                            ]),
                            _: 1
                          }, 8, ["model-value"])
                        ], 64))
                      : _createCommentVNode("", true),
                    ($setup.supportImportantConversations || $setup.supportSensitiveConversations)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_NcActionSeparator),
                          ($setup.supportImportantConversations)
                            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                                key: "toggle-important",
                                type: "checkbox",
                                description: $options.labelImportantHint,
                                "model-value": $props.item.isImportant,
                                onClick: _cache[5] || (_cache[5] = $event => ($options.toggleImportant(!$props.item.isImportant)))
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_IconMessageAlertOutline, { size: 20 })
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Important conversation')), 1)
                                ]),
                                _: 1
                              }, 8, ["description", "model-value"]))
                            : _createCommentVNode("", true),
                          ($setup.supportSensitiveConversations)
                            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                                key: "toggle-sensitive",
                                type: "checkbox",
                                description: $options.t('spreed', 'Hide message text'),
                                "model-value": $props.item.isSensitive,
                                onClick: _cache[6] || (_cache[6] = $event => ($options.toggleSensitive(!$props.item.isSensitive)))
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_IconShieldLockOutline, { size: 20 })
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Sensitive conversation')), 1)
                                ]),
                                _: 1
                              }, 8, ["description", "model-value"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
          ]),
          key: "1"
        }
      : ($props.item.token)
        ? {
            name: "actions",
            fn: _withCtx(() => [
              _createVNode(_component_NcActionButton, {
                key: "join-conversation",
                "close-after-click": "",
                onClick: $options.onActionClick
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconArrowRight, {
                    class: "bidirectional-icon",
                    size: 20
                  })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Join conversation')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_NcActionButton, {
                key: "copy-link",
                onClick: _withModifiers($options.handleCopyLink, ["stop"])
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconContentCopy, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Copy link')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            key: "2"
          }
        : undefined,
    ($setup.isLeaveDialogOpen || $setup.isDeleteDialogOpen)
      ? {
          name: "extra",
          fn: _withCtx(() => [
            ($setup.isLeaveDialogOpen)
              ? (_openBlock(), _createBlock(_component_NcDialog, {
                  key: 0,
                  open: $setup.isLeaveDialogOpen,
                  "onUpdate:open": _cache[8] || (_cache[8] = $event => (($setup.isLeaveDialogOpen) = $event)),
                  name: $options.t('spreed', 'Leave conversation')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString($options.dialogLeaveMessage), 1),
                    ($setup.supportsArchive && !$props.item.isArchived)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($options.t('spreed', 'You can archive this conversation instead.')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  actions: _withCtx(() => [
                    _createVNode(_component_NcButton, {
                      variant: "tertiary",
                      onClick: _cache[7] || (_cache[7] = $event => ($setup.isLeaveDialogOpen = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.t('spreed', 'No')), 1)
                      ]),
                      _: 1
                    }),
                    ($setup.supportsArchive && !$props.item.isArchived)
                      ? (_openBlock(), _createBlock(_component_NcButton, {
                          key: 0,
                          variant: "secondary",
                          onClick: $options.toggleArchiveConversation
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($options.t('spreed', 'Archive conversation')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_NcButton, {
                      variant: "warning",
                      onClick: $options.leaveConversation
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.t('spreed', 'Yes')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["open", "name"]))
              : _createCommentVNode("", true),
            ($setup.isDeleteDialogOpen)
              ? (_openBlock(), _createBlock(_component_NcDialog, {
                  key: 1,
                  open: $setup.isDeleteDialogOpen,
                  "onUpdate:open": _cache[10] || (_cache[10] = $event => (($setup.isDeleteDialogOpen) = $event)),
                  name: $options.t('spreed', 'Delete conversation'),
                  message: $options.dialogDeleteMessage
                }, {
                  actions: _withCtx(() => [
                    _createVNode(_component_NcButton, {
                      variant: "tertiary",
                      onClick: _cache[9] || (_cache[9] = $event => ($setup.isDeleteDialogOpen = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.t('spreed', 'No')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_NcButton, {
                      variant: "error",
                      onClick: $options.deleteConversation
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.t('spreed', 'Yes')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["open", "name", "message"]))
              : _createCommentVNode("", true)
          ]),
          key: "3"
        }
      : undefined
  ]), 1032, ["name", "title", "data-nav-id", "class", "actions-aria-label", "to", "bold", "counter-number", "counter-type", "compact", "onClick", "onUpdate:menuOpen"]))
}